import React from "react";
import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandProvider";
import { useTheme } from "@/context/ThemeProvider";

export default function Logo({ to = "/", className = "" }) {
  const brand = useBrand();
  const { theme } = useTheme();
  const name = brand.platform_name || "GeolyShop";
  const src = theme === "dark" && brand.logo_dark_url ? brand.logo_dark_url : brand.logo_url || "";

  return (
    <Link to={to} className={`flex items-center gap-2 group ${className}`} data-testid="logo-link">
      {src ? (
        <img src={src} alt={name} className="h-8 w-auto max-w-[180px] object-contain" data-testid="logo-image" />
      ) : (
        <>
          <span className="relative flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground font-display font-extrabold text-lg">
            {name.charAt(0).toUpperCase()}
            <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-brand pulse-dot" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tighter" data-testid="logo-text">{name}</span>
        </>
      )}
    </Link>
  );
}
